if (!customElements.get('map-section')) {
    // js/sections/MapSection.js
    class MapSection extends HTMLElement {
    constructor() {
        super();
        this.delegateElement = new main_default(this);
        this.options = JSON.parse(this.getAttribute("data-section-settings"));
        this.mapPositions = [];
        this.desktopMarkers = [];
        this.desktopMapElement = null;
        this.mobileMarkers = [];
        this.mobileMapElements = [];
        if (this.options["apiKey"] && this.options["mapAddresses"].length > 0) {
        this._loadScript().then(this._initMaps.bind(this));
        }
        this._attachListeners();
    }
    onUnload() {
        this.delegateElement.off("click");
        if (this.options["apiKey"] && this.options["mapAddresses"].length > 0) {
        google.maps.event.clearInstanceListeners(window);
        }
    }
    onBlockSelect(event2) {
        this._showStore(event2.target);
    }
    _attachListeners() {
        this.delegateElement.on("click", '[data-action="toggle-store"]', (event2, target) => {
        this._showStore(target.closest(".map__store-item"));
        });
    }
    _showStore(storeItem) {
        let toggleButton = storeItem.querySelector('[data-action="toggle-store"]');
        if (Responsive.getCurrentBreakpoint() !== "phone" && toggleButton.getAttribute("aria-expanded") === "true") {
        return;
        }
        if (toggleButton.getAttribute("aria-expanded") === "true") {
        toggleButton.setAttribute("aria-expanded", "false");
        Animation.slideUp(storeItem.querySelector(".map__store-collapsible"));
        } else {
        toggleButton.setAttribute("aria-expanded", "true");
        Animation.slideDown(storeItem.querySelector(".map__store-collapsible"));
        }
        Dom.getSiblings(storeItem).forEach((storeItemToClose) => {
        storeItemToClose.querySelector('[data-action="toggle-store"]').setAttribute("aria-expanded", "false");
        Animation.slideUp(storeItemToClose.querySelector(".map__store-collapsible"));
        });
        let storeIndex = parseInt(storeItem.getAttribute("data-store-index"));
        this.desktopMapElement.panTo(this.mapPositions[storeIndex]);
        this.desktopMarkers.forEach((marker, index) => {
        marker.setMap(this.desktopMapElement);
        if (index === storeIndex) {
            marker.icon.fillColor = this.options["markerActiveColor"];
        } else {
            marker.icon.fillColor = this.options["markerColor"];
        }
        });
    }
    _loadScript() {
        return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.options["apiKey"]}`;
        });
    }
    _initMaps() {
        const mapOptions = {
        zoom: this.options["zoom"],
        draggable: this.options["draggableMap"],
        clickableIcons: false,
        scrollwheel: this.options["draggableMap"],
        disableDoubleClickZoom: true,
        disableDefaultUI: !this.options["showMapControls"],
        styles: JSON.parse(this.querySelector("[data-gmap-style]").innerHTML)
        };
        this.desktopMapElement = new google.maps.Map(this.querySelector(".map__map-container--desktop .map__gmap"), mapOptions);
        this.mobileMapElements = [];
        this.querySelectorAll(".map__map-container--mobile .map__gmap").forEach((item, index) => {
        this.mobileMapElements[index] = new google.maps.Map(item, mapOptions);
        });
        this._geocodeAddresses();
        google.maps.event.addDomListener(window, "resize", () => {
        const desktopCenter = this.desktopMapElement.getCenter();
        google.maps.event.trigger(this.desktopMapElement, "resize");
        this.desktopMapElement.setCenter(desktopCenter);
        this.mobileMapElements.forEach((mobileMap) => {
            const mobileCenter = mobileMap.getCenter();
            google.maps.event.trigger(mobileMap, "resize");
            mobileMap.setCenter(mobileCenter);
        });
        });
    }
    _onMarkerClicked(address) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, "_blank", 'noopener');
    }
    _geocodeAddresses() {
        let geocoder = new google.maps.Geocoder();
        this.options["mapAddresses"].forEach((address, index) => {
        geocoder.geocode({ address }, (results, status) => {
            if (status !== google.maps.GeocoderStatus.OK) {
            if (Shopify.designMode) {
            }
            } else {
            const position = results[0].geometry.location;
            this.mapPositions[index] = position;
            this.desktopMarkers[index] = new google.maps.Marker({
                map: index === 0 ? this.desktopMapElement : null,
                position,
                icon: {
                path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                fillColor: index === 0 ? this.options["markerActiveColor"] : this.options["markerColor"],
                fillOpacity: 1,
                anchor: new google.maps.Point(12, 30),
                strokeWeight: 0
                }
            });
            this.mobileMarkers[index] = new google.maps.Marker({
                map: this.mobileMapElements[index],
                position,
                icon: {
                path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                fillColor: this.options["markerActiveColor"],
                fillOpacity: 1,
                anchor: new google.maps.Point(12, 30),
                strokeWeight: 0
                }
            });
            this.desktopMarkers[index].addListener("click", this._onMarkerClicked.bind(this, address));
            this.mobileMarkers[index].addListener("click", this._onMarkerClicked.bind(this, address));
            if (index === 0) {
                this.desktopMapElement.setCenter(position);
            }
            this.mobileMapElements[index].setCenter(position);
            }
        });
        });
    }
    };

    customElements.define('map-section', MapSection);
}